import { createFileRoute } from '@tanstack/react-router';
import { PlatformTenantRolesTable } from '../../pages/platform/tenants/roles/PlatformTenantRolesTable';

// Pestaña Roles del drill-down. El tenantId sale del PATH (no del user logueado) y se pasa por prop
// a la tabla, que consume platformApi.*TenantRole sobre ese tenant.
export const Route = createFileRoute('/_authenticated/_layout/platform/tenants/$tenantId/roles')({
    component: TenantRoles,
});

function TenantRoles() {
    const { tenantId } = Route.useParams();
    return <PlatformTenantRolesTable tenantId={tenantId} />;
}
